import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMintatantervFejlesztesek, createMintatantervFejlesztesek, updateMintatantervFejlesztesek, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import "./SzakjelentesCreate.css";
import SideTile from "../SideTile";
import { useDropzone } from "react-dropzone";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { MINTATANTERVFEJLESZTESEK_TRANSLATIONS } from './MintatantervFejlesztesekTranslations';
import { TANANYAG_FEJLESZTESEK_OPTIONS, TANTARGYI_KOHERENCIA_OPTIONS, AZONOSITOTT_PROBLEMATIPUSOK_OPTIONS, MAGYAR_ANGOL_OPTIONS,  } from "./MintatantervFejlesztesekOptions";


const MintatantervFejlesztesekContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const [mintatantervData, setMintatantervData] = useState({
        filling_status: 1,
    });

    const [tananyagFejlesztesek, setTananyagFejlesztesek] = useState([]);
    const [tananyagFejlesztesekMegjegyzes, setTananyagFejlesztesekMegjegyzes] = useState("");
    const [tantargyiKoherencia, setTantargyiKoherencia] = useState("");
    const [azonositottProblematipusok, setAzonositottProblematipusok] = useState([]);
    const [azonositottProblematipusokEgyeb, setAzonositottProblematipusokEgyeb] = useState("");
    const [azonositottProblematipusokMegjegyzes, setAzonositottProblematipusokMegjegyzes] = useState("");
    const [magyarAngol, setMagyarAngol] = useState("kivalo"); // Default to first option

    const [isNew, setIsNew] = useState(true);
    const [images, setImages] = useState([]);
    const [finalized, setFinalized] = useState(false);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Translations and options setup
    const t = loading ? {} : (MINTATANTERVFEJLESZTESEK_TRANSLATIONS[language] || MINTATANTERVFEJLESZTESEK_TRANSLATIONS.hu);
    const tananyagFejlesztesekOptions = loading ? [] : (TANANYAG_FEJLESZTESEK_OPTIONS[language] || TANANYAG_FEJLESZTESEK_OPTIONS.hu);
    const tantargyiKoherenciaOptions = loading ? [] : (TANTARGYI_KOHERENCIA_OPTIONS[language] || TANTARGYI_KOHERENCIA_OPTIONS.hu);
    const azonositottProblematipusokOptions = loading ? [] : (AZONOSITOTT_PROBLEMATIPUSOK_OPTIONS[language] || AZONOSITOTT_PROBLEMATIPUSOK_OPTIONS.hu);
    const magyarAngolOptions = loading ? [] : (MAGYAR_ANGOL_OPTIONS[language] || MAGYAR_ANGOL_OPTIONS.hu);

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getMintatantervFejlesztesek(szakId);
                const rawData = response.data.data.mintatantervFejlesztesek;
                if (rawData && rawData.length > 0) {
                    const data = rawData[0];

                    // Backend returns a placeholder row with filling_status = 0 if no record exists
                    if (data.filling_status === 0) {
                        const newData = { filling_status: 1 };
                        await createMintatantervFejlesztesek(szakId, newData);
                        window.location.reload(); // Ensure SideTile status refreshes to red
                        return;
                    }
                    setMintatantervData(data);
                    setFinalized(data.filling_status === 3);
                    await fetchImages();
                    
                    // Set individual fields from response
                    if (data.tananyag_fejlesztesek) {
                        const selected = data.tananyag_fejlesztesek.selected;
                        setTananyagFejlesztesek(Array.isArray(selected) ? selected : (selected ? [selected] : []));
                    }
                    if (data.tananyag_fejlesztesek_megjegyzes) setTananyagFejlesztesekMegjegyzes(data.tananyag_fejlesztesek_megjegyzes);
                    if (data.tantargyi_koherencia) setTantargyiKoherencia(data.tantargyi_koherencia.selected || "");
                    if (data.azonositott_problematipusok) setAzonositottProblematipusok(data.azonositott_problematipusok.selected || []);
                    if (data.azonositott_problematipusok_egyeb) setAzonositottProblematipusokEgyeb(data.azonositott_problematipusok_egyeb);
                    if (data.azonositott_problematipusok_megjegyzes) setAzonositottProblematipusokMegjegyzes(data.azonositott_problematipusok_megjegyzes);
                    if (data.magyar_angol) setMagyarAngol(data.magyar_angol.selected || "");
                    
                    setIsNew(false);
                } else {
                    // Automatically set filling_status to 1 and save it if there's no data yet
                    await createMintatantervFejlesztesek(szakId, { filling_status: 1 });
                    window.location.reload();  // Reload page after record creation
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // Ha 404-es hiba lép fel, új bejegyzés létrehozása filling_status: 1-gyel
                    const newRecord = { filling_status: 1 };
                    try {
                        await createMintatantervFejlesztesek(szakId, newRecord);
                        window.location.reload();  // Frissítjük az oldalt a sikeres létrehozás után
                    } catch (createError) {
                        console.error("Error creating new record:", createError);
                    }
                } else {
                    console.log("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId]);

    const fetchImages = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakok/${szakId}/images/mintatanterv_fejlesztesek_image`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch images');
            }

            const data = await response.json();
            setImages(data.data || []);
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const handleChange = (field, value) => {
        setMintatantervData(prevState => ({
            ...prevState,
            [field]: value, // Save the updated HTML content
        }));
    };

    const handleDrop = async (acceptedFiles) => {
        if (finalized) return; // Véglegesítés után ne lehessen képet feltölteni
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', 'mintatanterv_fejlesztesek_image');

        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to upload image');
            }

            const uploadResponse = await response.json();

            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => [...prevImages, { ...uploadResponse, image_path: imagePath }]);
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };


    const handleDeleteImage = async (imageId) => {
        if (finalized) return; // Véglegesítés után ne lehessen törölni képet

        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });

            setImages(images.filter(img => img.id !== imageId));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };

    const handleTananyagFejlesztesekMegjegyzes = (value) => {
        setTananyagFejlesztesekMegjegyzes(value);
    };

    const handleAzonositottProblematipusokEgyebChange = (value) => {
        setAzonositottProblematipusokEgyeb(value);
    };

    const handleAzonositottProblematipusokMegjegyzes = (value) => {
        setAzonositottProblematipusokMegjegyzes(value);
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/fejlesztesi-javaslatok`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/kotelezo-szakmai-gyakorlat`);
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...mintatantervData, 
                filling_status: 2, // Always save with status 2
                tananyag_fejlesztesek: tananyagFejlesztesek.length > 0 ? buildMultiSelectData(tananyagFejlesztesek, TANANYAG_FEJLESZTESEK_OPTIONS) : null,
                tananyag_fejlesztesek_megjegyzes: tananyagFejlesztesekMegjegyzes,
                tantargyi_koherencia: buildRadioData(tantargyiKoherencia, TANTARGYI_KOHERENCIA_OPTIONS),
                azonositott_problematipusok: buildMultiSelectData(azonositottProblematipusok, AZONOSITOTT_PROBLEMATIPUSOK_OPTIONS),
                azonositott_problematipusok_egyeb: azonositottProblematipusokEgyeb,
                azonositott_problematipusok_megjegyzes: azonositottProblematipusokMegjegyzes,
                magyar_angol: buildRadioData(magyarAngol, MAGYAR_ANGOL_OPTIONS),
            };
            try {
                if (isNew) {
                    await createMintatantervFejlesztesek(szakId, updatedData);
                } else {
                    await updateMintatantervFejlesztesek(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [mintatantervData, isNew, szakId, registerSaveHandler, unregisterSaveHandler, tananyagFejlesztesek, tananyagFejlesztesekMegjegyzes, tantargyiKoherencia, azonositottProblematipusok, azonositottProblematipusokEgyeb, azonositottProblematipusokMegjegyzes, magyarAngol]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { 
            ...mintatantervData, 
            filling_status: status,
            tananyag_fejlesztesek: tananyagFejlesztesek.length > 0 ? buildMultiSelectData(tananyagFejlesztesek, tananyagFejlesztesekOptions) : null,
            tananyag_fejlesztesek_megjegyzes: tananyagFejlesztesekMegjegyzes,
            tantargyi_koherencia: buildRadioData(tantargyiKoherencia, tantargyiKoherenciaOptions),
            azonositott_problematipusok: buildMultiSelectData(azonositottProblematipusok, azonositottProblematipusokOptions),
            azonositott_problematipusok_egyeb: azonositottProblematipusokEgyeb,
            azonositott_problematipusok_megjegyzes: azonositottProblematipusokMegjegyzes,
            magyar_angol: buildRadioData(magyarAngol, magyarAngolOptions),
        };

        try {
            if (isNew) {
                await createMintatantervFejlesztesek(szakId, updatedData);
            } else {
                await updateMintatantervFejlesztesek(szakId, updatedData);
            }
            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        const hasAllRadioSelections = tananyagFejlesztesek.length > 0 && tantargyiKoherencia && azonositottProblematipusok.length > 0 && magyarAngol;

        // Check "egyéb" text field only if "egyéb" is selected
        const egyebFieldsValid = 
            (azonositottProblematipusok !== 'egyeb' || hasContent(azonositottProblematipusokEgyeb));

        return (
            hasAllRadioSelections && egyebFieldsValid
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts?.requiredFields || "Minden szöveges mezőt ki kell tölteni!");
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = (e) => {
        handleSubmit(e, 2);
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile id={szakId} texts={t.sidebar}
                isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                    <form onSubmit={(e) => handleSubmit(e, 2)}> 
                    <div className="card">
                        <h3>{t.section1?.title}</h3>
                        <p>{t.section1?.description}</p>
                        <h4>{t.section1.subtitle}</h4> 
                        <div className="form-group">
                            {tananyagFejlesztesekOptions.map((option) => (
                            <div className="checkbox-group" key={option.value}>
                                <input
                                    type="checkbox"
                                    id={`tananyag_fejlesztesek_${option.value}`}
                                    name="tananyag_fejlesztesek"
                                    value={option.value}
                                    checked={tananyagFejlesztesek.includes(option.value)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setTananyagFejlesztesek([...tananyagFejlesztesek, option.value]);
                                        } else {
                                            setTananyagFejlesztesek(tananyagFejlesztesek.filter(val => val !== option.value));
                                        }
                                    }}
                                    disabled={finalized}
                                />
                            <label htmlFor={`tananyag_fejlesztesek_${option.value}`}>{option.label}</label>
                            </div>
                            ))}
                        </div>
                        <h4>{t.section1?.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="tananyag_fejlesztesek_megjegyzes"
                                value={tananyagFejlesztesekMegjegyzes}
                                onChange={handleTananyagFejlesztesekMegjegyzes}
                                disabled={finalized}
                            />
                        </div>

                        <h3>{t.section2?.title}</h3>
                        <p>{t.section2?.description}</p>
                        <h4>{t.section2?.subtitle}</h4>
                        <div className="form-group">
                            {tantargyiKoherenciaOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`tantargyi_koherencia_${option.value}`}
                                    name="tantargyi_koherencia"
                                    value={option.value}
                                    checked={tantargyiKoherencia === option.value}
                                    onChange={(e) => setTantargyiKoherencia(e.target.value)}
                                    disabled={finalized}
                                />
                            <label htmlFor={`tantargyi_koherencia_${option.value}`}>{option.label}</label>
                            </div>
                            ))}
                        </div>

                        <h3>{t.section3?.title}</h3>
                        <div className="form-group">
                            {azonositottProblematipusokOptions.map((option) => (
                            <div className="checkbox-group" key={option.value}>
                                <input
                                    type="checkbox"
                                    id={`azonositott_problematipusok_${option.value}`}
                                    name="azonositott_problematipusok"
                                    value={option.value}
                                    checked={azonositottProblematipusok.includes(option.value)}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setAzonositottProblematipusok([
                                                ...azonositottProblematipusok,
                                                option.value
                                            ]);
                                        } else {
                                            setAzonositottProblematipusok(
                                            azonositottProblematipusok.filter(val => val !== option.value)
                                            );
                                        }
                                    }}
                                    disabled={finalized}
                                />
                            <label htmlFor={`azonositott_problematipusok_${option.value}`}>{option.label}</label>
                            </div>
                            ))}
                            {azonositottProblematipusok.includes("egyeb") && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="azonositott_problematipusok_egyeb"
                                        value={azonositottProblematipusokEgyeb}
                                        onChange={handleAzonositottProblematipusokEgyebChange}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                        
                        <h4>{t.section3?.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="azonositott_problematipusok_megjegyzes"
                                value={azonositottProblematipusokMegjegyzes}
                                onChange={handleAzonositottProblematipusokMegjegyzes}
                                disabled={finalized}
                            />
                        </div>

                        <h3>{t.section4?.title}</h3>
                        <p>{t.section4?.description}</p>
                        <h4>{t.section4?.subtitle}</h4>
                        <div className="form-group">
                            {magyarAngolOptions.map((option) => (
                            <div className="radio-group" key={option.value}>
                                <input
                                    type="radio"
                                    id={`magyar_angol_${option.value}`}
                                    name="magyar_angol"
                                    value={option.value}
                                    checked={magyarAngol === option.value}
                                    disabled={true}
                                />
                            <label htmlFor={`magyar_angol_${option.value}`}>{option.label}</label>
                            </div>
                            ))}
                        </div>
                    </div>

                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        {finalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const MintatantervFejlesztesek = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <MintatantervFejlesztesekContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default MintatantervFejlesztesek;
